import type { PropsWithChildren } from 'react';
import { type IntlShape } from 'react-intl';

import * as styles from '../../../buttons/notify-button/NotifyButton.sty.js';
import { Text } from '../../../typography/text/Text.js';
import { showToast } from '../../toast/Toast.js';
import { CopyPermissionsButton } from '../components/CopyPermissionsButton.js';
import { notificationMessages } from '../messages.js';

function ToastMessage({ children }: Readonly<PropsWithChildren>) {
  return <Text className={styles.toast}>{children}</Text>;
}

/** @internal */
export function noWritePermissionToast(
  intl: IntlShape,
  notificationEnabled: boolean,
) {
  showToast({
    title: intl.formatMessage(notificationMessages.noPermissionsHeading, {
      notificationEnabled,
    }),
    message: (
      <ToastMessage>
        {intl.formatMessage(notificationMessages.copyPermissions)}.
      </ToastMessage>
    ),
    actions: <CopyPermissionsButton readOrWrite="write" />,
    position: 'bottom-left',
    type: 'critical',
  });
}

/** @internal */
export function notificationLimitReachedToast(
  intl: IntlShape,
  notificationType: string,
) {
  showToast({
    title: intl.formatMessage(notificationMessages.limitReachedToastHeading),
    message: (
      <ToastMessage>
        {intl.formatMessage(notificationMessages.limitReached, {
          notificationType,
        })}
      </ToastMessage>
    ),
    position: 'bottom-left',
    type: 'critical',
  });
}

/** @internal */
export function notificationGenericErrorToast(intl: IntlShape) {
  showToast({
    title: intl.formatMessage(notificationMessages.genericError),
    message: (
      <ToastMessage>
        {intl.formatMessage(notificationMessages.genericErrorMessage)}
      </ToastMessage>
    ),
    position: 'bottom-left',
    type: 'critical',
  });
}
